import React from "react";
import { Share2, Upload, ClipboardCheck, Inbox, Copy } from "lucide-react";

const navClass = (isActive) =>
  `w-full flex items-center justify-between px-3 py-2 rounded-md text-sm transition-colors duration-200 ${
    isActive ? "bg-primary/10 text-primary font-semibold" : "text-foreground hover:bg-secondary/60"
  }`;

export const CuratorSidebar = ({ nodeTypeEntries, active, setActive, stats, reviewCount, contributionCount, dupCount }) => (
  <aside className="lg:col-span-3">
    <nav className="bg-card border border-border rounded-lg p-2 space-y-0.5" data-testid="kg-sidebar">
      {nodeTypeEntries.map((nt) => (
        <button key={nt.key} onClick={() => setActive(nt.key)} data-testid={`kg-nav-${nt.key}`} className={navClass(active === nt.key)}>
          <span>{nt.label}</span>
          <span className="text-xs text-muted-foreground">{stats[nt.key] ?? 0}</span>
        </button>
      ))}
      <div className="h-px bg-border my-1" />
      <button onClick={() => setActive("relationships")} data-testid="kg-nav-relationships" className={navClass(active === "relationships")}>
        <span className="flex items-center gap-2"><Share2 className="w-4 h-4" /> Relationships</span>
        <span className="text-xs text-muted-foreground">{stats.edges ?? 0}</span>
      </button>
      <button onClick={() => setActive("import")} data-testid="kg-nav-import"
        className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors duration-200 ${
          active === "import" ? "bg-primary/10 text-primary font-semibold" : "text-foreground hover:bg-secondary/60"
        }`}>
        <Upload className="w-4 h-4" /> Import CSV
      </button>
      <button onClick={() => setActive("duplicates")} data-testid="kg-nav-duplicates" className={navClass(active === "duplicates")}>
        <span className="flex items-center gap-2"><Copy className="w-4 h-4" /> Merge duplicates</span>
        {dupCount > 0 && <span className="text-xs bg-primary text-primary-foreground rounded-full px-2 py-0.5 font-semibold">{dupCount}</span>}
      </button>
      <button onClick={() => setActive("review")} data-testid="kg-nav-review" className={navClass(active === "review")}>
        <span className="flex items-center gap-2"><ClipboardCheck className="w-4 h-4" /> Review Queue</span>
        {reviewCount > 0 && <span className="text-xs bg-primary text-primary-foreground rounded-full px-2 py-0.5 font-semibold">{reviewCount}</span>}
      </button>
      <button onClick={() => setActive("contributions")} data-testid="kg-nav-contributions" className={navClass(active === "contributions")}>
        <span className="flex items-center gap-2"><Inbox className="w-4 h-4" /> Contributions</span>
        {contributionCount > 0 && <span className="text-xs bg-accent text-accent-foreground rounded-full px-2 py-0.5 font-semibold">{contributionCount}</span>}
      </button>
    </nav>
  </aside>
);
